import React from "react"

export default function Error404(): JSX.Element {
  return (
    <>
      <h1>404 Not Found</h1>

      <h2>The requested URL was not found.</h2>
    </>
  )
}
